const baseUrl =
  import.meta.VITE_POOGLE_URL ?? 'https://poogle-api.stg.trypura.io'

const getPoogleRecommendations = async (sku = null) => {
  try {
    if (!sku) {
      throw new Error('SKU is required')
    }

    const response = await fetch(`${baseUrl}/api/v1/similar/${sku}`)

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()
    console.log('data', data)
    return data.recommendations
  } catch (error) {
    console.error('Error fetching Poogle recommendations:', error)
    throw error
  }
}

export { getPoogleRecommendations }
